var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChips = function SvgChips(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#chips_svg__a)",
    d: "m28.025 7.037-.008 2.256c-.003 1.02-.686 2.038-2.052 2.815-2.75 1.565-7.225 1.565-9.993 0-1.393-.788-2.087-1.823-2.085-2.854q.002-1.129.007-2.256c-.004 1.033.692 2.066 2.085 2.853 2.769 1.566 7.241 1.566 9.993 0 1.366-.776 2.049-1.795 2.052-2.814"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M25.973 9.851c-2.75 1.566-7.225 1.566-9.993 0-1.393-.787-2.09-1.822-2.085-2.853v.296c.058.984.752 1.958 2.08 2.71 2.768 1.566 7.24 1.566 9.992 0 1.366-.777 2.049-1.796 2.053-2.815v-.005c-.065.97-.746 1.928-2.046 2.667z",
    opacity: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#E87500",
    d: "M25.973 11.954c-2.75 1.566-7.225 1.566-9.993 0-1.393-.788-2.09-1.823-2.085-2.854v.296c.058.985.752 1.959 2.08 2.71 2.768 1.566 7.24 1.566 9.992 0 1.366-.776 2.049-1.795 2.053-2.814v-.005c-.065.97-.746 1.928-2.046 2.667z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#chips_svg__b)",
    d: "M25.94 4.181c2.768 1.566 2.783 4.104.033 5.67s-7.225 1.566-9.993 0-2.783-4.104-.031-5.67c2.75-1.566 7.223-1.566 9.99 0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF9F05",
    d: "M24.76 4.85c2.115 1.197 2.128 3.136.026 4.332s-5.518 1.196-7.634 0c-2.115-1.196-2.126-3.135-.024-4.332 2.1-1.196 5.518-1.196 7.633 0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#E87500",
    d: "M17.13 5.353c2.1-1.197 5.52-1.197 7.634 0 .95.538 1.474 1.225 1.574 1.926.127-.868-.399-1.763-1.574-2.429-2.115-1.196-5.531-1.196-7.633 0-1.159.66-1.674 1.545-1.55 2.407.1-.694.616-1.372 1.55-1.903z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#chips_svg__c)",
    d: "m19.88 7.944.874-.497q.174.274-.145.455-.31.175-.728.042m1.434-1.412q-.19-.247.062-.39.252-.145.64-.01zm2.604-.888-.524-.296-.538.307a4.6 4.6 0 0 0-1.315-.373 2.2 2.2 0 0 0-1.424.285q-.457.26-.473.515t.22.5q.235.243.513.476l.009.005-1.051.6a1.3 1.3 0 0 1-.201-.16 1 1 0 0 1-.152-.189l.512-.255-.818-.538-1.227.52q.076.246.343.537.268.29.712.56l-.473.268.526.298.489-.278q.721.325 1.474.363t1.356-.307q.505-.289.507-.592a.82.82 0 0 0-.23-.567 4 4 0 0 0-.432-.42l.83-.473a1 1 0 0 1 .255.265l-.465.375.952.465.936-.655a1.3 1.3 0 0 0-.273-.45 3 3 0 0 0-.567-.479l.529-.301"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#chips_svg__d)",
    d: "m28.025 4.78-.008 2.257c-.003 1.018-.686 2.037-2.052 2.814-2.75 1.566-7.225 1.566-9.993 0-1.393-.788-2.087-1.823-2.085-2.854q.002-1.128.007-2.256c-.004 1.033.692 2.066 2.085 2.853 2.769 1.566 7.241 1.566 9.993 0 1.366-.776 2.049-1.795 2.052-2.814"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M25.973 7.594c-2.75 1.566-7.225 1.566-9.993 0-1.393-.787-2.09-1.822-2.085-2.853v.296c.058.984.752 1.958 2.08 2.71 2.768 1.566 7.24 1.566 9.992 0 1.366-.777 2.049-1.796 2.053-2.814v-.006c-.065.97-.746 1.928-2.046 2.667z",
    opacity: 0.5
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#E87500",
    d: "M25.973 9.697c-2.75 1.566-7.225 1.566-9.993 0-1.393-.787-2.09-1.822-2.085-2.854v.296c.058.985.752 1.959 2.08 2.71 2.768 1.566 7.24 1.566 9.992 0 1.366-.778 2.049-1.795 2.053-2.814V7.03c-.065.97-.746 1.928-2.046 2.667z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#chips_svg__e)",
    d: "M25.94 1.924c2.768 1.566 2.783 4.104.033 5.67s-7.225 1.566-9.993 0-2.783-4.104-.031-5.67c2.75-1.565 7.223-1.565 9.99 0"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF9F05",
    d: "M24.76 2.594c2.115 1.196 2.128 3.135.026 4.331s-5.518 1.196-7.634 0c-2.115-1.196-2.126-3.135-.024-4.331 2.1-1.197 5.518-1.197 7.633 0"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#E87500",
    d: "M17.13 3.096c2.1-1.197 5.52-1.197 7.634 0 .95.538 1.474 1.225 1.574 1.926.127-.868-.399-1.763-1.574-2.428-2.115-1.197-5.531-1.197-7.633 0-1.159.66-1.674 1.544-1.55 2.407.1-.695.616-1.373 1.55-1.903z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#chips_svg__f)",
    d: "m19.88 5.687.874-.497q.174.274-.145.456-.31.174-.728.04m1.434-1.412q-.19-.247.062-.39.252-.145.64-.01zm2.604-.888-.524-.295-.538.306a4.6 4.6 0 0 0-1.315-.373 2.2 2.2 0 0 0-1.424.285q-.457.26-.473.515-.015.256.22.499.235.242.513.475l.009.005-1.051.6q-.108-.07-.201-.16a1 1 0 0 1-.152-.188l.512-.255-.818-.538-1.227.52q.076.245.343.536.268.29.712.56l-.473.269.526.296.489-.278q.721.325 1.474.362.753.038 1.356-.307.505-.288.507-.591a.82.82 0 0 0-.23-.567 4 4 0 0 0-.432-.42l.83-.473a1 1 0 0 1 .255.265l-.465.375.952.464.936-.654a1.3 1.3 0 0 0-.273-.45 3 3 0 0 0-.567-.48l.529-.3"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#chips_svg__g)",
    d: "m14.304 11.821-.007 2.257c-.004 1.019-.687 2.037-2.053 2.814-2.752 1.566-7.224 1.566-9.993 0C.86 16.106.164 15.072.168 14.04l.007-2.256c-.003 1.033.692 2.066 2.086 2.853 2.768 1.566 7.242 1.566 9.992 0 1.366-.778 2.05-1.795 2.053-2.814z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M12.252 14.636c-2.75 1.566-7.224 1.566-9.993 0C.868 13.846.172 12.813.176 11.78v.296c.058.985.752 1.959 2.08 2.71 2.768 1.566 7.24 1.566 9.992 0 1.366-.776 2.049-1.795 2.053-2.814v-.005c-.066.97-.745 1.928-2.047 2.667z",
    opacity: 0.5
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#E87500",
    d: "M12.252 16.74c-2.75 1.566-7.224 1.566-9.993 0C.868 15.953.172 14.92.176 13.886v.296c.058.985.752 1.959 2.08 2.71 2.768 1.566 7.24 1.566 9.992 0 1.366-.776 2.049-1.795 2.053-2.814v-.005c-.066.97-.745 1.928-2.047 2.667z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#chips_svg__h)",
    d: "M12.217 8.967c2.768 1.566 2.783 4.104.033 5.67s-7.224 1.566-9.993 0c-2.768-1.566-2.782-4.104-.03-5.67 2.75-1.565 7.222-1.565 9.99 0"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF9F05",
    d: "M11.042 9.637c2.114 1.196 2.127 3.135.026 4.332-2.102 1.196-5.519 1.196-7.635 0-2.115-1.197-2.126-3.136-.024-4.332 2.1-1.196 5.518-1.196 7.633 0"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#E87500",
    d: "M3.41 10.14c2.1-1.197 5.519-1.197 7.634 0 .95.537 1.473 1.224 1.574 1.926.126-.869-.399-1.764-1.574-2.429-2.115-1.196-5.531-1.196-7.633 0-1.16.66-1.674 1.544-1.55 2.407.102-.694.618-1.372 1.55-1.903z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#chips_svg__i)",
    d: "m6.16 12.727.873-.497q.173.273-.145.455-.309.176-.728.041m1.433-1.412q-.19-.246.063-.391.252-.143.638-.01zm2.604-.888-.526-.296-.538.307a4.6 4.6 0 0 0-1.315-.373 2.2 2.2 0 0 0-1.424.285q-.459.26-.472.515-.017.255.22.5.234.244.512.475l.01.006-1.052.599a1.3 1.3 0 0 1-.201-.16 1 1 0 0 1-.154-.188l.513-.255-.819-.538-1.224.52q.075.246.342.537.27.29.71.56l-.472.268.524.296.488-.278q.723.325 1.474.362.754.038 1.357-.306.505-.288.507-.592a.82.82 0 0 0-.23-.567 4 4 0 0 0-.435-.42l.832-.473q.164.12.256.265l-.465.375.952.463.935-.655a1.3 1.3 0 0 0-.272-.45 2.8 2.8 0 0 0-.568-.479l.53-.301"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#chips_svg__j)",
    d: "m14.304 9.563-.007 2.257c-.004 1.018-.687 2.037-2.053 2.814-2.752 1.566-7.224 1.566-9.993 0C.86 13.848.164 12.814.168 11.78l.007-2.256c-.003 1.033.692 2.066 2.086 2.854 2.768 1.565 7.242 1.565 9.992 0 1.366-.777 2.05-1.796 2.053-2.815z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M12.252 12.378c-2.75 1.565-7.224 1.565-9.993 0C.868 11.59.172 10.558.176 9.524v.296c.058.985.752 1.958 2.08 2.71 2.768 1.566 7.24 1.566 9.992 0 1.366-.777 2.049-1.795 2.053-2.814V9.71c-.066.97-.745 1.929-2.047 2.668z",
    opacity: 0.5
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#E87500",
    d: "M12.252 14.482c-2.75 1.565-7.224 1.565-9.993 0-1.391-.788-2.087-1.82-2.083-2.854v.296c.058.985.752 1.959 2.08 2.71 2.768 1.566 7.24 1.566 9.992 0 1.366-.777 2.049-1.795 2.053-2.814v-.005c-.066.97-.745 1.928-2.047 2.667z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#chips_svg__k)",
    d: "M12.217 6.708c2.768 1.565 2.783 4.103.033 5.67-2.75 1.565-7.224 1.565-9.993 0-2.768-1.567-2.782-4.105-.03-5.67 2.75-1.566 7.222-1.566 9.99 0"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF9F05",
    d: "M11.042 7.377c2.114 1.197 2.127 3.135.026 4.332-2.102 1.196-5.519 1.196-7.635 0-2.115-1.197-2.126-3.135-.024-4.332 2.1-1.196 5.518-1.196 7.633 0"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "#E87500",
    d: "M3.41 7.88c2.1-1.195 5.519-1.195 7.634 0 .95.539 1.473 1.226 1.574 1.927.126-.868-.399-1.763-1.574-2.428-2.115-1.197-5.531-1.197-7.633 0-1.16.66-1.674 1.544-1.55 2.407.102-.694.618-1.372 1.55-1.903z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#chips_svg__l)",
    d: "m6.16 10.47.873-.497q.173.274-.145.456-.309.175-.728.043M7.593 9.06q-.19-.247.063-.39.252-.145.638-.01zm2.604-.887-.526-.296-.538.306a4.6 4.6 0 0 0-1.315-.373 2.2 2.2 0 0 0-1.424.286q-.459.26-.472.514-.017.255.22.5.234.244.512.476l.01.005-1.052.6a1.3 1.3 0 0 1-.201-.16 1 1 0 0 1-.154-.189l.513-.254-.819-.538-1.224.52q.075.245.342.536.27.29.71.56l-.472.269.524.296.488-.278q.723.325 1.474.362.753.038 1.357-.307.505-.288.507-.591a.82.82 0 0 0-.23-.567 4 4 0 0 0-.435-.42l.832-.474q.164.122.256.266l-.465.375.952.463.935-.655a1.3 1.3 0 0 0-.272-.45 2.8 2.8 0 0 0-.568-.48l.53-.3"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#chips_svg__m)",
    d: "m14.304 7.307-.007 2.256c-.004 1.019-.687 2.037-2.053 2.814-2.752 1.566-7.224 1.566-9.993 0C.86 11.59.164 10.557.168 9.523l.007-2.256C.172 8.3.867 9.333 2.261 10.121c2.768 1.566 7.242 1.566 9.992 0 1.366-.777 2.05-1.796 2.053-2.814z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M12.252 10.12c-2.75 1.567-7.224 1.567-9.993 0C.868 9.334.172 8.3.176 7.268v.296c.058.985.752 1.959 2.08 2.71 2.768 1.566 7.24 1.566 9.992 0 1.366-.778 2.049-1.795 2.053-2.814v-.005c-.066.97-.745 1.928-2.047 2.667z",
    opacity: 0.5
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "#E87500",
    d: "M12.252 12.225c-2.75 1.566-7.224 1.566-9.993 0C.868 11.437.172 10.402.176 9.37v.296c.058.985.752 1.959 2.08 2.71 2.768 1.566 7.24 1.566 9.992 0 1.366-.778 2.049-1.795 2.053-2.814v-.005c-.066.97-.745 1.928-2.047 2.667z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#chips_svg__n)",
    d: "M12.217 4.45c2.768 1.567 2.783 4.105.033 5.67-2.75 1.566-7.224 1.566-9.993 0-2.768-1.565-2.782-4.103-.03-5.67 2.75-1.565 7.222-1.565 9.99 0"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF9F05",
    d: "M11.042 5.12c2.114 1.196 2.127 3.135.026 4.332-2.102 1.196-5.519 1.196-7.635 0-2.115-1.197-2.126-3.136-.024-4.332 2.1-1.196 5.518-1.196 7.633 0"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "#E87500",
    d: "M3.41 5.624c2.1-1.196 5.519-1.196 7.634 0 .95.538 1.473 1.225 1.574 1.926.126-.868-.399-1.763-1.574-2.428-2.115-1.196-5.531-1.196-7.633 0-1.16.66-1.674 1.544-1.55 2.407.102-.694.618-1.372 1.55-1.903z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#chips_svg__o)",
    d: "m6.16 8.213.873-.497q.173.274-.145.456-.309.176-.728.041m1.433-1.411q-.19-.247.063-.391.252-.143.638-.01zm2.604-.888-.526-.296-.538.307a4.6 4.6 0 0 0-1.315-.373 2.2 2.2 0 0 0-1.424.285q-.459.26-.472.514-.017.256.22.5.234.242.512.474l.01.006-1.052.599a1.3 1.3 0 0 1-.201-.16 1 1 0 0 1-.154-.188l.513-.255-.819-.538-1.224.52q.075.246.342.537.27.29.71.56l-.472.268.524.296.488-.278q.723.325 1.474.362.754.038 1.357-.306.505-.288.507-.592a.82.82 0 0 0-.23-.567 4 4 0 0 0-.435-.42l.832-.473q.164.12.256.265l-.465.375.952.465.935-.655a1.3 1.3 0 0 0-.272-.45 2.8 2.8 0 0 0-.568-.479l.53-.301"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#chips_svg__p)",
    d: "m14.304 5.052-.007 2.256c-.004 1.019-.687 2.038-2.053 2.814-2.752 1.566-7.224 1.566-9.993 0C.86 9.335.164 8.302.168 7.27l.007-2.257C.172 6.045.867 7.078 2.261 7.866c2.768 1.566 7.242 1.566 9.992 0 1.366-.777 2.05-1.796 2.053-2.814z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M12.252 7.866c-2.75 1.566-7.224 1.566-9.993 0C.868 7.078.172 6.046.176 5.012v.296c.058.985.752 1.959 2.08 2.71 2.768 1.566 7.24 1.566 9.992 0 1.366-.778 2.049-1.795 2.053-2.814V5.2c-.066.97-.745 1.928-2.047 2.667z",
    opacity: 0.5
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "#E87500",
    d: "M12.252 9.97c-2.75 1.566-7.224 1.566-9.993 0C.868 9.182.172 8.148.176 7.116v.296c.058.985.752 1.959 2.08 2.71 2.768 1.566 7.24 1.566 9.992 0 1.366-.776 2.049-1.795 2.053-2.814v-.005c-.066.97-.745 1.928-2.047 2.667z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#chips_svg__q)",
    d: "M12.217 2.196C14.985 3.762 15 6.3 12.25 7.866s-7.224 1.565-9.993 0C-.51 6.3-.525 3.762 2.227 2.196c2.75-1.566 7.222-1.566 9.99 0"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF9F05",
    d: "M11.042 2.865c2.114 1.196 2.127 3.135.026 4.332-2.102 1.196-5.519 1.196-7.635 0C1.318 6 1.307 4.06 3.409 2.865c2.1-1.196 5.518-1.196 7.633 0"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fill: "#E87500",
    d: "M3.41 3.367c2.1-1.196 5.519-1.196 7.634 0 .95.538 1.473 1.225 1.574 1.927.126-.869-.399-1.764-1.574-2.429-2.115-1.196-5.531-1.196-7.633 0-1.16.66-1.674 1.544-1.55 2.407.102-.694.618-1.372 1.55-1.903z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#chips_svg__r)",
    d: "m6.16 5.958.873-.496q.173.273-.145.455-.309.176-.728.041m1.433-1.411q-.19-.246.063-.391.252-.143.638-.01zm2.604-.888-.526-.296-.538.307a4.6 4.6 0 0 0-1.315-.373 2.2 2.2 0 0 0-1.424.285q-.459.26-.472.515-.017.255.22.5.234.243.512.475l.01.006-1.052.599a1.2 1.2 0 0 1-.201-.16 1 1 0 0 1-.154-.188l.513-.255-.819-.538-1.224.52q.075.245.342.536.27.29.71.56l-.472.27.524.295.488-.278q.723.325 1.474.362.753.038 1.357-.306.505-.288.507-.592a.82.82 0 0 0-.23-.567 4 4 0 0 0-.435-.42l.832-.473q.164.12.256.265l-.465.375.952.463.935-.655a1.3 1.3 0 0 0-.272-.45 2.8 2.8 0 0 0-.568-.479l.53-.301"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#chips_svg__s)",
    d: "M24.024 17.002q-.001 1.128-.007 2.257c-.003 1.018-.686 2.037-2.052 2.814-2.752 1.566-7.225 1.566-9.993 0-1.393-.788-2.087-1.822-2.085-2.854q.002-1.128.007-2.256c-.004 1.033.692 2.066 2.085 2.854 2.769 1.565 7.243 1.565 9.993 0 1.366-.779 2.05-1.796 2.052-2.815"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M21.973 19.817c-2.75 1.565-7.225 1.565-9.993 0-1.393-.788-2.087-1.823-2.085-2.854v.296c.058.985.752 1.959 2.08 2.71 2.768 1.566 7.24 1.566 9.992 0 1.366-.777 2.049-1.795 2.052-2.814v-.006c-.066.97-.745 1.929-2.046 2.668",
    opacity: 0.5
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fill: "#E87500",
    d: "M21.973 21.923c-2.75 1.565-7.225 1.565-9.993 0-1.393-.788-2.087-1.823-2.085-2.854v.296c.058.985.752 1.958 2.08 2.71 2.768 1.566 7.24 1.566 9.992 0 1.366-.777 2.049-1.796 2.052-2.814v-.006c-.066.97-.745 1.928-2.046 2.668"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#chips_svg__t)",
    d: "M21.94 14.149c2.768 1.565 2.783 4.103.033 5.67-2.75 1.565-7.225 1.565-9.993 0-2.768-1.567-2.783-4.105-.031-5.67 2.75-1.566 7.223-1.566 9.99 0"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF9F05",
    d: "M20.765 14.818c2.114 1.196 2.127 3.135.025 4.331s-5.518 1.197-7.634 0c-2.115-1.196-2.126-3.135-.024-4.331 2.1-1.197 5.518-1.197 7.633 0"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fill: "#E87500",
    d: "M13.13 15.32c2.1-1.197 5.518-1.197 7.632 0 .95.538 1.474 1.225 1.575 1.926.126-.868-.4-1.763-1.575-2.428-2.114-1.197-5.53-1.197-7.632 0-1.16.66-1.674 1.544-1.55 2.407.101-.694.618-1.372 1.55-1.903z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#chips_svg__u)",
    d: "m15.882 17.911.874-.497q.173.274-.145.456-.307.174-.729.041m1.434-1.412q-.19-.247.062-.39.252-.145.64-.01zm2.603-.887-.525-.296-.538.306a4.5 4.5 0 0 0-1.315-.373 2.2 2.2 0 0 0-1.424.285q-.46.261-.473.515-.015.255.22.5.235.244.513.476l.009.005-1.051.6a1.3 1.3 0 0 1-.201-.16 1 1 0 0 1-.154-.188l.512-.255-.818-.538-1.225.52q.077.245.343.536.268.29.71.56l-.472.269.523.296.489-.278a4 4 0 0 0 1.474.362q.753.038 1.357-.307.504-.288.507-.592a.82.82 0 0 0-.231-.566 4 4 0 0 0-.434-.42l.831-.474q.164.121.257.266l-.465.375.952.462.935-.654a1.3 1.3 0 0 0-.273-.45 2.9 2.9 0 0 0-.567-.48l.529-.3"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#chips_svg__v)",
    d: "M24.024 14.748q-.001 1.127-.007 2.256c-.003 1.019-.686 2.037-2.052 2.814-2.752 1.566-7.225 1.566-9.993 0-1.393-.787-2.087-1.822-2.085-2.854q.002-1.127.007-2.256c-.004 1.033.692 2.066 2.085 2.854 2.769 1.566 7.243 1.566 9.993 0 1.366-.779 2.05-1.796 2.052-2.815"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M21.973 17.562c-2.75 1.566-7.225 1.566-9.993 0-1.393-.788-2.087-1.823-2.085-2.854v.296c.058.985.752 1.959 2.08 2.71 2.768 1.566 7.24 1.566 9.992 0 1.366-.776 2.049-1.795 2.052-2.814v-.005c-.066.97-.745 1.928-2.046 2.667",
    opacity: 0.5
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fill: "#E87500",
    d: "M21.973 19.666c-2.75 1.566-7.225 1.566-9.993 0-1.393-.788-2.087-1.823-2.085-2.854v.296c.058.985.752 1.959 2.08 2.71 2.768 1.566 7.24 1.566 9.992 0 1.366-.777 2.049-1.795 2.052-2.814v-.006c-.066.97-.745 1.929-2.046 2.668"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#chips_svg__w)",
    d: "M21.94 11.892c2.768 1.566 2.783 4.104.033 5.67s-7.225 1.565-9.993 0c-2.768-1.567-2.783-4.105-.031-5.67 2.75-1.566 7.223-1.566 9.99 0"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF9F05",
    d: "M20.765 12.56c2.114 1.197 2.127 3.136.025 4.332-2.102 1.197-5.518 1.197-7.634 0-2.115-1.196-2.126-3.135-.024-4.331 2.1-1.197 5.518-1.197 7.633 0"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fill: "#E87500",
    d: "M13.13 13.063c2.1-1.196 5.518-1.196 7.632 0 .95.538 1.474 1.225 1.575 1.926.126-.868-.4-1.763-1.575-2.428-2.114-1.197-5.53-1.197-7.632 0-1.16.66-1.674 1.544-1.55 2.407.101-.694.618-1.372 1.55-1.903z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#chips_svg__x)",
    d: "m15.882 15.654.874-.496q.173.273-.145.455-.307.175-.729.043m1.434-1.411q-.19-.247.062-.391t.64-.01zm2.603-.888-.525-.296-.538.306a4.6 4.6 0 0 0-1.315-.373 2.2 2.2 0 0 0-1.424.286q-.46.26-.473.514-.015.256.22.5t.513.476l.009.005-1.051.6a1.3 1.3 0 0 1-.201-.16 1 1 0 0 1-.154-.188l.512-.255-.818-.538-1.225.52q.077.245.343.536.268.29.71.56l-.472.269.523.296.489-.278q.722.325 1.474.362.753.038 1.357-.307.504-.288.507-.591a.82.82 0 0 0-.231-.567 4 4 0 0 0-.434-.42l.831-.474q.164.122.257.266l-.465.375.952.463.935-.655a1.3 1.3 0 0 0-.273-.45 2.9 2.9 0 0 0-.567-.48l.529-.3"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "chips_svg__a",
    x1: 29.824,
    x2: 15.025,
    y1: 4.664,
    y2: 12.291,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEA05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#FFD905"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#FFAF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9F05"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "chips_svg__b",
    x1: 20.337,
    x2: 22.459,
    y1: 3.209,
    y2: 16.677,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEA05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#FFD905"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#FFAF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9F05"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "chips_svg__c",
    x1: 20.225,
    x2: 22.346,
    y1: 3.228,
    y2: 16.696,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEA05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#FFD905"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#FFAF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9F05"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "chips_svg__d",
    x1: 29.824,
    x2: 15.025,
    y1: 2.407,
    y2: 10.034,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEA05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#FFD905"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#FFAF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9F05"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "chips_svg__e",
    x1: 20.337,
    x2: 22.459,
    y1: 0.952,
    y2: 14.42,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEA05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#FFD905"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#FFAF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9F05"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "chips_svg__f",
    x1: 20.225,
    x2: 22.346,
    y1: 0.971,
    y2: 14.437,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEA05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#FFD905"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#FFAF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9F05"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "chips_svg__g",
    x1: 16.104,
    x2: 1.306,
    y1: 9.45,
    y2: 17.077,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEA05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#FFD905"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#FFAF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9F05"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "chips_svg__h",
    x1: 6.613,
    x2: 8.734,
    y1: 7.995,
    y2: 21.463,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEA05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#FFD905"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#FFAF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9F05"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "chips_svg__i",
    x1: 6.504,
    x2: 8.625,
    y1: 8.013,
    y2: 21.479,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEA05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#FFD905"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#FFAF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9F05"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "chips_svg__j",
    x1: 16.104,
    x2: 1.306,
    y1: 7.192,
    y2: 14.819,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEA05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#FFD905"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#FFAF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9F05"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "chips_svg__k",
    x1: 6.613,
    x2: 8.734,
    y1: 5.737,
    y2: 19.203,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEA05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#FFD905"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#FFAF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9F05"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "chips_svg__l",
    x1: 6.504,
    x2: 8.625,
    y1: 5.757,
    y2: 19.223,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEA05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#FFD905"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#FFAF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9F05"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "chips_svg__m",
    x1: 16.104,
    x2: 1.306,
    y1: 4.935,
    y2: 12.563,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEA05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#FFD905"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#FFAF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9F05"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "chips_svg__n",
    x1: 6.613,
    x2: 8.734,
    y1: 3.48,
    y2: 16.946,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEA05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#FFD905"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#FFAF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9F05"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "chips_svg__o",
    x1: 6.504,
    x2: 8.625,
    y1: 3.498,
    y2: 16.965,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEA05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#FFD905"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#FFAF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9F05"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "chips_svg__p",
    x1: 16.104,
    x2: 1.306,
    y1: 2.68,
    y2: 10.308,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEA05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#FFD905"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#FFAF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9F05"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "chips_svg__q",
    x1: 6.613,
    x2: 8.734,
    y1: 1.224,
    y2: 14.691,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEA05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#FFD905"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#FFAF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9F05"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "chips_svg__r",
    x1: 6.504,
    x2: 8.625,
    y1: 1.243,
    y2: 14.711,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEA05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#FFD905"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#FFAF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9F05"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "chips_svg__s",
    x1: 25.824,
    x2: 11.027,
    y1: 14.631,
    y2: 22.258,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEA05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#FFD905"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#FFAF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9F05"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "chips_svg__t",
    x1: 16.336,
    x2: 18.457,
    y1: 13.178,
    y2: 26.644,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEA05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#FFD905"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#FFAF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9F05"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "chips_svg__u",
    x1: 16.227,
    x2: 18.348,
    y1: 13.196,
    y2: 26.663,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEA05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#FFD905"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#FFAF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9F05"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "chips_svg__v",
    x1: 25.824,
    x2: 11.027,
    y1: 12.374,
    y2: 20.002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEA05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#FFD905"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#FFAF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9F05"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "chips_svg__w",
    x1: 16.336,
    x2: 18.457,
    y1: 10.919,
    y2: 24.387,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEA05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#FFD905"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#FFAF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9F05"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "chips_svg__x",
    x1: 16.227,
    x2: 18.348,
    y1: 10.939,
    y2: 24.407,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEA05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#FFD905"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#FFAF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9F05"
  })))));
};
export default SvgChips;